<template>
    <div class="segment-controls" :class="[variant]">
        <segment
            v-for="option in options"
            :key="option.value"
            :active="modelValue === option.value"
            :hover="hover === option.value"
            :variant="props.variant"
            :model-value="modelValue"
            @click="selectTab(option.value)"
            @mouseover="hoverTab(option.value)"
            @mouseleave="hoverTab(null)"
        >
            <template v-if="option.iconComponent" #icon>
                <component
                    :is="option.iconComponent"
                    v-bind="option.iconProps"
                    :state="modelValue === option.value"
                    :class="{ 'active-icon': modelValue === option.value }"
                />
            </template>
            <div v-if="option.label" class="segment-label-content">
                <span>{{ $t(option.label) }}</span>
                <glyph-icon v-if="option.showArrow && option.direction" :class="['sort-arrow', option.direction]" :type="GlyphType.CollapseTiny" />
            </div>
        </segment>
    </div>
</template>

<script setup>
import { watch } from 'vue';
import { Segment, ComponentVariant, GlyphIcon, GlyphType } from 'ihunter-pathfinder-components';

const props = defineProps({
    options: {
        type: Array,
        required: true,
        validator: (value) => value.every((opt) => 'value' in opt),
    },
    modelValue: {
        type: [String, Number, null],
        required: true,
    },
    variant: {
        type: String,
        default: ComponentVariant.Default,
    },
    hover: {
        type: [String, Number, null],
        default: null,
    },
});

const emit = defineEmits(['update:modelValue', 'update:hover']);

const selectTab = (value) => {
    emit('update:modelValue', value);
};

const hoverTab = (value) => {
    emit('update:hover', value);
};
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.segment-controls {
    display: flex;
    padding: Pathfinder.$space-25;
    gap: Pathfinder.$space-25;
    background: var(--surface-border);
    width: 100%;
    border-radius: Pathfinder.$space-50;
}

.segment-label-content {
    display: flex;
    align-items: center;
    gap: Pathfinder.$space-50;
}

.sort-arrow {
    transition: transform 0.2s;
    fill: currentColor;
}

.sort-arrow.desc {
    /* Upward arrow */
    transform: rotate(180deg);
}

.sortlist {
    padding: 0;
    gap: 0;
    background: transparent;
    width: max-content;
}

.thumbnail {
    padding: 0;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: Pathfinder.$space-100;
    background: transparent;
}

.thumbnail > :last-child:nth-child(10) {
    grid-column: 2;
}

.thumbnail-tight {
    padding: 0;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: Pathfinder.$space-150;
    background: transparent;
}

.tab {
    padding: 0;
    background: transparent;
    gap: 0;
    fill: var(--on-surface-alt);

    .active-icon {
        fill: var(--on-surface);
    }
}
</style>
